import GCInstant from '@play-co/gcinstant';

export function trackFirstButtonTap(opts: {
  feature: string;
  $subFeature: string;
}) {
  GCInstant.trackFirstButtonTap(opts);
}
